import NameField from "@components/commerce/baseForms/NameField";

type Props = {
    firstName: string;
    lastName: string;
    country: string;
    errors: [string, string];
    isInvalid: [boolean, boolean];
};

export const PhoneticNames = ({ firstName, lastName, country, isInvalid, errors }: Props) => {
    if (country !== "JP") return null;

    const [isInvalidFirstName, isInvalidLastName] = isInvalid;
    const [firstNameError, lastNameError] = errors;

    return (
        <>
            <NameField
                error={lastNameError}
                isInvalid={isInvalidLastName}
                header={lastName}
                id="phoneticLastName"
            />
            <NameField
                error={firstNameError}
                isInvalid={isInvalidFirstName}
                header={firstName}
                id="phoneticFirstName"
            />
        </>
    );
};
